import { render, staticRenderFns } from "./adminnsec.vue?vue&type=template&id=c9414a2e&"
import script from "./adminnsec.vue?vue&type=script&lang=js&"
export * from "./adminnsec.vue?vue&type=script&lang=js&"
import style0 from "./adminnsec.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports